exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".snackbar-error div{background-color:#ff1a09 !important}", ""]);

